module.exports = __webpack_public_path__ + "img/right-arrow.35d298c4.svg";